import React from 'react';
import { FieldErrors, Control, Controller } from 'react-hook-form';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { SourceCombobox } from '../common/SourceCombobox';
import { VALIDATION_MESSAGES } from '../../utils/validationMessages';

interface OnboardingSourceProps {
  errors: FieldErrors<any>;
  source: string;
  control: Control<any>;
  fieldsDisabled?: boolean;
}

export const OnboardingSource: React.FC<OnboardingSourceProps> = ({
  errors,
  source,
  control,
  fieldsDisabled = false,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-foreground">
          Source of Customer Onboarding
        </h3>
        <p className="text-sm text-muted-foreground">
          Please select your onboarding source
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="source">Onboarding Source</Label>
          <Controller
            name="source"
            control={control}
            rules={{ required: 'Please select an onboarding source' }}
            render={({ field }: { field: any }) => (
              <SourceCombobox
                id="source"
                items={['Website', 'IB_Referral', 'Marketing / Sales'] as const}
                placeholder="Select source..."
                value={field.value}
                onChange={field.onChange}
                disabled={fieldsDisabled}
              />
            )}
          />
          {errors.source && (
            <p className="text-sm text-destructive">
              {String(errors.source.message)}
            </p>
          )}
        </div>
        {source === 'IB_Referral' && (
          <div className="space-y-2">
            <Label htmlFor="referralCode">
              Referral Code <span className="text-red-500">*</span>
            </Label>
            <Controller
              name="referralCode"
              control={control}
              rules={{
                required: 'Referral code is required',
                minLength: {
                  value: 10,
                  message: VALIDATION_MESSAGES.referralCode.invalid,
                },
                maxLength: {
                  value: 10,
                  message: VALIDATION_MESSAGES.referralCode.maxLength,
                },
              }}
              render={({ field }: { field: any }) => (
                <Input
                  id="referralCode"
                  type="text"
                  placeholder="Enter referral code (e.g., ABC1234)"
                  value={field.value}
                  disabled={fieldsDisabled}
                  onChange={e => {
                    const upperValue = e.target.value.toUpperCase();
                    field.onChange(upperValue);
                  }}
                  className="border-blue-100 focus:blue-400 w-full uppercase"
                />
              )}
            />
            {errors.referralCode && (
              <p className="text-sm text-destructive">
                {String(errors.referralCode.message)}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OnboardingSource;
